import { useState } from "react";
import axios from "axios";

function AddClientTicket() {

const [title,setTitle]=useState("");
const [description,setDescription]=useState("");

const saveTicket=async(e)=>{

e.preventDefault();

try{

const token=
localStorage.getItem("token");

const clientId=
localStorage.getItem("client_id");

console.log(
"Client ID:",
clientId
);

const response=
await axios.post(

"https://saleupcall.com/api/Ticket/add-ticket.php",

{
client_id:clientId,
title:title,
description:description,
priority:"Medium"
},

{
headers:{
Authorization:
`Bearer ${token}`
}
}

);

console.log(
response.data
);

if(response.data.status){

alert(
"Ticket Created : "+
response.data.ticket_number
);

setTitle("");
setDescription("");

}
else{

alert(
response.data.message
);

}

}
catch(error){

console.log(error);

alert(
"Error creating ticket"
);

}

};

return(

<div style={{padding:"20px"}}>

<h2>Create Ticket</h2>

<form onSubmit={saveTicket}>

<input
type="text"
placeholder="Title"
value={title}
onChange={(e)=>
setTitle(
e.target.value
)
}
required
/>

<br/><br/>

<textarea
placeholder="Description"
value={description}
onChange={(e)=>
setDescription(
e.target.value
)
}
rows="5"
required
/>

<br/><br/>

<button type="submit">

Create Ticket

</button>

</form>

</div>

);

}

export default AddClientTicket;